import {
  CompositeFilterDescriptor,
  SortDescriptor,
} from '@progress/kendo-data-query'
import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

interface MatrizConfigState {
  filter?: CompositeFilterDescriptor
  sort?: SortDescriptor[]
  mostrarRecargosCombustible: boolean
}

const initialState: MatrizConfigState = { mostrarRecargosCombustible: false }

const matrizConfigSlice = createSlice({
  name: 'matrizConfig',
  initialState,
  reducers: {
    setFilter: (
      state,
      action: PayloadAction<{ value?: CompositeFilterDescriptor }>,
    ) => {
      state.filter = action.payload.value
    },
    setSort: (state, action: PayloadAction<{ value?: SortDescriptor[] }>) => {
      state.sort = action.payload.value
    },
    setMostrarRecargosCombustible: (state, action: PayloadAction<{ value: boolean }>) => {
      state.mostrarRecargosCombustible = action.payload.value
    },
  },
})

export const { setFilter, setSort, setMostrarRecargosCombustible } = matrizConfigSlice.actions

const MatrizConfigReducer = matrizConfigSlice.reducer

export default MatrizConfigReducer
